import React from 'react';
import {
  Banner,
  Dock,
  Gutter,
  Layout,
  ScrollRegionFooter,
  SmallHeader,
} from '@axiom/ui';
import type { FormPropsChildren } from '@axiom/ui';

import type { ChatForm } from '../../../schema/spark/chat-form-schema';
import { useSparkSession } from '../../hooks/useSparkSession';

import { ChatInputBar } from './ChatInputBar';
import { ChatScrollDown } from './ChatScrollDown';
import { ChatQueuedPrompts } from './ChatQueuedPrompts';

export type ChatComposerProps = {
  fireSubmit: FormPropsChildren<ChatForm>['fireSubmit'];
  greeting: string;
  hasChat: boolean;
  values: FormPropsChildren<ChatForm>['values'];
};

export const ChatComposer = ({
  fireSubmit,
  greeting,
  hasChat,
  values,
}: ChatComposerProps) => {
  const {
    session: { status },
  } = useSparkSession();
  const { notice, setNotice } = status;

  const noticeType = typeof notice === 'string' ? 'warning' : notice?.type;

  return (
    <Dock fadeColor={hasChat ? 'panelLight' : undefined} name="CHAT_COMPOSER">
      <ScrollRegionFooter>
        {hasChat ? null : (
          <>
            <Layout position="center">
              <SmallHeader name="CHAT_GREETING">{greeting}</SmallHeader>
            </Layout>
            <Gutter bottom="88px" />
          </>
        )}
        <ChatScrollDown />
        <ChatQueuedPrompts />
        {notice ? (
          <Gutter bottom="24px" gutterType="margin">
            <Banner
              impact="high"
              name="CHAT_NOTICE"
              onDismiss={
                noticeType === 'error'
                  ? undefined
                  : () => {
                      setNotice(null);
                    }
              }
              type={noticeType}
            >
              {typeof notice === 'string' ? notice : notice.message}
            </Banner>
          </Gutter>
        ) : null}
        <ChatInputBar fireSubmit={fireSubmit} values={values} />
      </ScrollRegionFooter>
    </Dock>
  );
};
